const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1', '[::1]', '::1'];
const DEV_HOSTNAMES = ['dev.rezrate.com'];

// Returns 'LOCAL', 'DEV', or null. Anything unrecognized (including production) returns null so a missing or
// misspelled value can never put an environment label on production.
export const envLabel = ({ hostname = '', buildType = '' } = {}) => {
  const host = `${hostname}`.trim().toLowerCase();
  const build = `${buildType}`.trim().toLowerCase();

  if (LOCAL_HOSTNAMES.includes(host)) {
    return 'LOCAL';
  }
  if (build === 'liveproduction') {
    return null;
  }
  if (build === 'livedevelopment' || DEV_HOSTNAMES.includes(host)) {
    return 'DEV';
  }
  return null;
};

export const currentEnvLabel = () =>
  envLabel({
    hostname: typeof window !== 'undefined' ? window.location.hostname : '',
    buildType: process.env.REACT_APP_BUILD_TYPE,
  });
